import {
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { genderLabels } from 'platform/static-data/labels';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--birth-sex-title'];
const INPUT_LABEL = content['vet-info--birth-sex-label'];

const { gender } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    gender: radioUI({
      title: INPUT_LABEL,
      labels: genderLabels,
    }),
  },
  schema: {
    type: 'object',
    required: ['gender'],
    properties: { gender },
  },
};
